<nav
  class="no-scrollbar md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:h-screenmd:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10">

  @let myRoles = (myRoles$ | async);

  <div class="flex flex-row w-full align-middle px-6 py-4">
    <!-- Toggler -->
    <div class="content-center">
      <button
        class="cursor-pointer text-black opacity-50 md:hidden py-auto text-xl leading-none bg-transparent rounded border-none border-transparent"
        type="button" (click)="toggleMobileMenu()">
        <i class="fas fa-bars"></i>
      </button>
    </div>
    <div class="grow content-center pb-2">
      <a [routerLink]="['groups']" class="md:block align-middle whitespace-nowrap">
        <div class="hidden sm:block h-8">
          <img class="object-fit h-8 align-middle center mx-auto" src="assets/brand/atc_full_blueOnTransparent.png" />
        </div>
        <div class="block sm:hidden h-8">
          <img class="object-fit h-8 mx-auto" src="assets/brand/atc_full_blueOnTransparent.png" />
        </div>
      </a>
    </div>
    <div>
      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <!-- <app-notification-dropdown class="block"></app-notification-dropdown> -->
        </li>
        <li class="inline-block relative">
          <app-user-dropdown class="block"></app-user-dropdown>
        </li>
      </ul>
    </div>
  </div>

  <!-- Divider -->
  <hr class="mx-4 mb-4 hidden md:block min-w-full border-t border-blueGray-200" />

  <!-- Mobile Backdrop Overlay -->
  <div (click)="isOpen = false"
    class="fixed inset-0 z-20 bg-gray-100 bg-opacity-75 transition-opacity duration-300 ease-in-out md:hidden {{ isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none' }}">
  </div>

  <!-- Sidebar Menu Wrapper / Drawer -->
  <div
    class="fixed top-0 bottom-0 left-0 z-30 w-64 bg-white shadow-lg transition-transform duration-300 ease-in-out md:shadow-none md:translate-x-0 md:relative md:h-full md:w-full md:z-auto {{ isOpen ? 'translate-x-0' : '-translate-x-full' }}">
    <!-- Drawer Menu Content -->
    <div
      class="bg-white md:flex md:flex-col md:items-stretch py-4 md:pt-0 h-full min-h-screen items-center flex-1 overflow-y-auto no-scrollbar">
      <!-- Collapse header -->
      <div class="block md:hidden md:min-w-full mb-4 border-b border-solid border-blueGray-200 px-4">
        <div class="flex flex-row justify-between mb-4">
          <a [routerLink]="['groups']" (click)="onSubItemClick()"
            class="text-left md:pb-2 text-blueGray-600 whitespace-nowrap font-bold">
            <img class="object-fit max-h-10 mx-auto" src="assets/brand/atc_full_blueOnTransparent.png" />
          </a>
          <div class="w-6/12 flex justify-end">
            <button type="button" (click)="toggleMobileMenu()"
              class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Communities Section -->
      <div class="flex flex-col md:min-w-full">
        <!-- Heading -->
        <h6 [routerLink]="['groups']" (click)="onSubItemClick()"
          class="px-4 sticky top-0 bg-white z-20 md:min-w-full text-blueGray-500 text-sm font-bold block cursor-pointer uppercase pt-1 pb-2 no-underline">
          My Communities
        </h6>

        <!-- Navigation -->
        <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">

          @let user = (user$ | async);

          @if (loadingGroups$ | async) {
          <li>
            <div class="flex flex-row justify-start place-items-center">
              <div>
                <ngx-skeleton-loader [theme]="{height:'40px', width: '40px', margin:0}" count="1" appearance="circle" />
              </div>
              <div class="grow h-4 w-full mb-2 ml-2">
                <ngx-skeleton-loader count="1" appearance="line" />
              </div>
            </div>
          </li>
          } @else if(((groups$ | async) ?? []).length > 0) {

          @for (item of groups$ | async; track item.id) {
          <li class="block">
            <div class="sticky top-8 bg-white z-10">
              <a (click)="onGroupClick(item, $event)"
                class="cursor-pointer align-middle {{ expandedGroupId == item.id ? 'font-semibold' : 'font-medium' }} text-xs py-3 hover:font-semibold block">
                <div class="flex items-center justify-center">
                  <div class="flex-none">
                    @if (item.imageUrl) {
                    <img class="relative inline-block h-10 w-10 rounded-full bg-gray-100 object-cover object-center"
                      [src]="item.imageUrl" [alt]="item.name | initials" />
                    } @else {
                    <div
                      class="bg-primary-100 text-primary-500 align-middle text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
                      {{item.name | initials}}
                    </div>
                    }
                  </div>
                  <div class="flex-1 px-2 w-16">
                    <p class="text-blueGray-700 text-sm text-nowrap text-ellipsis">{{item.name}}</p>
                    <p class="text-xs font-light capitalize text-primary-500">{{item.memberType}}</p>
                  </div>
                </div>
              </a>
            </div>

            @if (expandedGroupId == item.id && item.memberStatus == membershipStatus.active) {
            <ul class="list-none pl-0 m-0">
              @if (item.groupType == groupType.school && myRoles?.management) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: false }">
                <a [routerLink]="['school', item.id, 'dashboard']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-gauge-high text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Dashboard</span>
                </a>
              </li>
              }

              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="[item.groupType == groupType.school ? 'school' : 'groups', item.id, 'noticeboard']"
                  (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-bullhorn text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Noticeboard</span>
                </a>
              </li>

              @if (item.groupType != groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['groups', item.id, 'events']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fa fa-calendar text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Events</span>
                </a>
              </li>
              }

              @if (item.groupType == groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'calendar']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-calendar-days text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Events Calendar</span>
                </a>
              </li>
              }

              @if (item.groupType != groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['groups', item.id, 'members']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-users text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Members</span>
                </a>
              </li>
              }

              @if (item.groupType != groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="[ 'groups', item.id, 'prayers']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-praying-hands text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Prayers</span>
                </a>
              </li>
              }

              @if (expandedGroupId == item.id && item.groupType == groupType.school && myRoles?.faculty) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
                <a [routerLink]="['school', item.id, 'faculty', user?.uid]" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-chalkboard-user text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">My Teaching Workspace</span>
                </a>
              </li>
              }

              @if (expandedGroupId == item.id && item.groupType == groupType.school && myRoles?.parents) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'parents', user?.uid,]" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-children text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">My Children</span>
                </a>
              </li>
              }

              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="[item.groupType == groupType.school ? 'school' : 'groups', item.id, 'giving']"
                  (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-credit-card text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">My Giving</span>
                </a>
              </li>

              @if (item.groupType == groupType.school && myRoles?.management) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'members']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-users text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Members</span>
                </a>
              </li>
              }

              @if (item.groupType == groupType.school && myRoles?.students) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'students', user?.uid]" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-child text-lg text-blueGray-500"></i>
                  </span>
                  <span class="inline">My Learning Space</span>
                </a>
              </li>
              }

              @if (item.groupType == groupType.school && myRoles?.management) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'grades']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-graduation-cap text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Grades</span>
                </a>
              </li>
              }

              @if (item.groupType == groupType.school && (myRoles?.management || myRoles?.faculty)) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="['school', item.id, 'lessons']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-book text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Lessons</span>
                </a>
              </li>
              }

              @if (item.groupType == groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
                <a [routerLink]="['school', item.id, 'quizzes']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-circle-question text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Quizzes</span>
                </a>
              </li>
              }

              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
                <a [routerLink]="[item.groupType == groupType.school ? 'school' : 'groups', item.id, 'albums']"
                  (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-images text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Albums</span>
                </a>
              </li>

              @if (myRoles?.management || myRoles?.admin) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
                <a [routerLink]="[item.groupType == groupType.school ? 'school' : 'groups', item.id, 'campaigns']"
                  (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-paper-plane text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Campaigns</span>
                </a>
              </li>
              }

              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="routerLinkActiveOptions">
                <a [routerLink]="[item.groupType == groupType.school ? 'school' : 'groups', item.id, 'accounting']"
                  (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-calculator text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Accounting</span>
                </a>
              </li>

              @if (item.groupType == groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['school', item.id, 'details']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-info-circle text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Details</span>
                </a>
              </li>
              }
              @if (item.groupType != groupType.school) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['groups', item.id]" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-info-circle text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Details</span>
                </a>
              </li>
              }

              @if (myRoles?.management || myRoles?.admin) {
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: false }">
                <a [routerLink]="['school', item.id, 'billing']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-credit-card text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Billing</span>
                </a>
              </li>
              }
            </ul>
            }
          </li>
          } @empty {
          <li class="items-center">
            <button type="button" routerLink="/groups/create" (click)="onSubItemClick()"
              class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 shadow hover:shadow-lg focus:outline-none text-left text-white mt-2 font-bold text-sm uppercase w-full rounded pl-4 py-3">
              <span class="flex justify-center items-center w-6">
                <i class="fas fa-church text-sm text-white"></i>
              </span>
              <span class="inline">Create Community</span>
            </button>
          </li>
          }
          }
        </ul>
      </div>

      <!-- Divider -->
      <hr class="m-4 md:min-w-full" />

      <!-- Platform admin tools (platformAdmin custom claim) -->
      @if (isPlatformAdmin) {
      <div class="flex flex-col md:min-w-full">
        <h6
          class="px-4 sticky top-0 bg-white z-20 md:min-w-full text-blueGray-500 text-sm font-bold block uppercase pt-1 pb-2 no-underline">
          Platform
        </h6>
        <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">
          <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass" [routerLinkActiveOptions]="{ exact: true }">
            <a routerLink="/platform/organization-requests" (click)="onSubItemClick()"
              class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
              <span class="flex justify-center items-center w-6">
                <i class="fas fa-clipboard-check text-blueGray-500 text-sm"></i>
              </span>
              <span class="inline">Organization Requests</span>
            </a>
          </li>
        </ul>
      </div>
      <hr class="m-4 md:min-w-full" />
      }

      <!-- Management Groups Section -->
      <div class="flex flex-col md:min-w-full">
        <!-- Heading -->
        <h6
          class="px-4 sticky top-0 bg-white z-20 md:min-w-full text-blueGray-500 text-sm font-bold block uppercase pt-1 pb-2 no-underline">
          Management Groups
        </h6>

        <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">
          @if (loadingOrganizations$ | async) {
          <li>
            <div class="flex flex-row justify-start place-items-center py-2">
              <div>
                <ngx-skeleton-loader [theme]="{height:'40px', width: '40px', margin:0}" count="1" appearance="circle" />
              </div>
              <div class="grow h-4 w-full mb-2 ml-2">
                <ngx-skeleton-loader count="1" appearance="line" />
              </div>
            </div>
          </li>
          } @else if (((organizations$ | async) ?? []).length > 0) {
          @for (org of organizations$ | async; track org.id) {
          <li class="block">
            <div class="sticky top-8 bg-white z-10">
              <a (click)="onOrgClick(org, $event)"
                class="cursor-pointer align-middle {{ expandedOrgId === org.id ? 'font-semibold' : 'font-medium' }} text-xs py-3 hover:font-semibold block">
                <div class="flex items-center justify-center">
                  <div class="flex-none">
                    @if (org.logoUrl) {
                    <img class="relative inline-block h-10 w-10 rounded-full bg-gray-100 object-cover object-center"
                      [src]="org.logoUrl" [alt]="org.name | initials" />
                    } @else {
                    <div
                      class="bg-primary-100 text-primary-500 align-middle text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
                      {{ org.name | initials }}
                    </div>
                    }
                  </div>
                  <div class="flex-1 px-2 w-16 min-w-0">
                    <p class="text-blueGray-700 text-sm truncate font-bold leading-tight">{{ org.name }}</p>
                    <p class="text-[10px] text-primary-600 font-medium">Governance Network</p>
                  </div>
                  <div class="flex-none">
                    <button type="button" (click)="toggleOrg(org.id, $event)"
                      class="p-1 text-blueGray-400 hover:text-blueGray-600 cursor-pointer">
                      <i class="fas text-[10px]" [class.fa-chevron-down]="expandedOrgId === org.id"
                        [class.fa-chevron-right]="expandedOrgId !== org.id"></i>
                    </button>
                  </div>
                </div>
              </a>
            </div>

            <!-- Sub-items when expanded -->
            @if (expandedOrgId === org.id) {
            <ul class="list-none pl-0 m-0">
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['/management', org.id]" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-sitemap text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Organizational Chart</span>
                </a>
              </li>
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['/management', org.id, 'members']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-users text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Members</span>
                </a>
              </li>
              <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
                [routerLinkActiveOptions]="{ exact: true }">
                <a [routerLink]="['/management', org.id, 'settings']" (click)="onSubItemClick()"
                  class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
                  <span class="flex justify-center items-center w-6">
                    <i class="fas fa-cog text-blueGray-500 text-sm"></i>
                  </span>
                  <span class="inline">Settings</span>
                </a>
              </li>
            </ul>
            }
          </li>
          }
          }
        </ul>
      </div>

      <!-- Divider -->
      <hr class="m-4 md:min-w-full" />
      <h6 class="px-4 md:min-w-full text-blueGray-500 text-sm uppercase font-bold block pt-1 pb-2 no-underline">
        My Channel
      </h6>

      <!-- Navigation -->
      <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">

        @let channel = (channel$ | async);

        @if (channel == null && (loadingChannel$ | async)){
        <li>
          <div class="flex flex-row justify-start place-items-center">
            <div>
              <ngx-skeleton-loader [theme]="{height:'40px', width: '40px', margin:0}" count="1" appearance="circle" />
            </div>
            <div class="grow h-4 w-full mb-2 ml-2">
              <ngx-skeleton-loader count="1" appearance="line" />
            </div>
          </div>
        </li>
        }

        @if (channel == null && !(loadingChannel$ | async)) {
        <li class="items-center">
          <button type="button" routerLink="/channel/create" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 shadow hover:shadow-lg focus:outline-none text-left text-white mt-2 font-bold text-sm uppercase w-full rounded pl-4 py-3">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-user-astronaut text-sm text-white"></i>
            </span>
            <span class="inline">Create Channel</span>
          </button>
        </li>
        }

        @if (channel){
        <li class="items-center">
          <a [routerLink]="['channel']" (click)="onSubItemClick()"
            class="text-blueGray-700 align-middle hover:text-blueGray-500 text-xs py-3 font-semibold block">
            <div class="flex items-center justify-center">
              <div class="flex-none">
                @if (channel.imageUrl){
                <img class="relative inline-block h-10 w-10 rounded-full bg-gray-100 object-cover object-center"
                  [src]="channel.imageUrl" [alt]="channel.name | initials" />
                } @else {
                <div
                  class="bg-primary-100 text-primary-500 align-middle text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
                  {{channel.name | initials}}
                </div>
                }
              </div>
              <div class="flex-1 px-2 text-blueGray-700 hover:text-blueGray-500 text-sm">
                {{channel.name}}
              </div>
            </div>
          </a>
        </li>
        }

        @if (channel) {
        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
          <a routerLink="/videos" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-video text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">My Videos</span>
          </a>
        </li>
        }
        @if (channel) {
        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass">
          <a routerLink="/articles" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-book-open text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">My Articles</span>
          </a>
        </li>
        }
      </ul>

      <!-- Profile Divider -->
      <hr class="m-4 md:min-w-full" />
      <h6 class="px-4 md:min-w-full text-blueGray-500 text-sm uppercase font-bold block pt-1 pb-2 no-underline">
        My Profile
      </h6>

      <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">
        <li class="items-center">
          <a [routerLink]="['/profile/details']" (click)="onSubItemClick()"
            class="text-blueGray-700 align-middle hover:text-blueGray-500 text-xs py-3 font-semibold block">
            <div class="flex items-center justify-center">
              <div class="flex-none">
                @if (user?.photoURL) {
                <img class="relative inline-block h-10 w-10 rounded-full bg-gray-100 object-cover object-center"
                  [src]="user?.photoURL" [alt]="user?.name | initials" />
                } @else {
                <div
                  class="bg-primary-100 text-primary-500 align-middle text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
                  {{user?.name | initials}}
                </div>
                }
              </div>
              <div class="flex-1 px-2 text-blueGray-700 hover:text-blueGray-500 text-sm">
                {{user?.name ?? 'Unknown'}}
              </div>
            </div>
          </a>
        </li>

        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/profile/details']" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-id-card text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">Profile Details</span>
          </a>
        </li>

        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/profile/settings']" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-cog text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">Settings</span>
          </a>
        </li>

        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/profile/giving']" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-hand-holding-dollar text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">My Giving</span>
          </a>
        </li>

        <li class="pl-2 items-center" [routerLinkActive]="routerActiveClass"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/profile/certificates']" (click)="onSubItemClick()"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-certificate text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">Certificates</span>
          </a>
        </li>
      </ul>

      <!-- Profile Divider -->
      <hr class="m-4 md:min-w-full" />
      <h6 class="px-4 md:min-w-full text-blueGray-500 text-sm uppercase font-bold block pt-1 pb-2 no-underline">
        Documentation
      </h6>

      <ul class="md:flex-col md:min-w-full flex flex-col list-none px-4">
        <li class="pl-2 items-center">
          <a (click)="onSubItemClick()" (click)="goToLink('https://docs.atchurch.app/how-to-guides')"
            class="grid grid-cols-[1.5rem_1fr] items-center gap-x-2 text-blueGray-700 hover:text-blueGray-500 text-sm py-3 font-semibold cursor-pointer">
            <span class="flex justify-center items-center w-6">
              <i class="fas fa-info-circle text-blueGray-500 text-sm"></i>
            </span>
            <span class="inline">How To Guides</span>
          </a>
        </li>
      </ul>

    </div>
  </div>
  <!-- </div> -->
</nav>